/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S5_Li4Inputs */

const tr_servis_s5_li4 = /** @type {(inputs: Servis_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adli / idari makam talebi`)
};

const en_servis_s5_li4 = /** @type {(inputs: Servis_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request of a judicial / administrative authority`)
};

const de_servis_s5_li4 = /** @type {(inputs: Servis_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersuchen einer Justiz- oder Verwaltungsbehörde`)
};

const ru_servis_s5_li4 = /** @type {(inputs: Servis_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требование судебного / административного органа`)
};

/**
* | output |
* | --- |
* | "Request of a judicial / administrative authority" |
*
* @param {Servis_S5_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s5_li4 = /** @type {((inputs?: Servis_S5_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S5_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s5_li4(inputs)
	if (locale === "de") return de_servis_s5_li4(inputs)
	if (locale === "ru") return ru_servis_s5_li4(inputs)
	return tr_servis_s5_li4(inputs)
});